module.exports = __webpack_public_path__ + "img/ob-apk.38399c6f.webp";